import React, { createContext, useContext } from 'react';
import { useConnectionHandler, useSocket } from "../../../lib";
import { SocketStatus } from "../../../../../shared/config";
var SocketContext = /*#__PURE__*/createContext({
  socketRef: {
    current: null
  },
  addEventHandler: function addEventHandler() {},
  socketStatus: SocketStatus.idle,
  reconnect: function reconnect() {},
  setStatus: function setStatus() {}
});
export var SocketProvider = function SocketProvider(_ref) {
  var children = _ref.children,
    token = _ref.token,
    config = _ref.config;
  var value = useConnectionHandler(useSocket(config, token));
  return /*#__PURE__*/React.createElement(SocketContext.Provider, {
    value: value
  }, children);
};
export var useSocketContext = function useSocketContext() {
  return useContext(SocketContext);
};